export default {
    setProducts: (state, products) => { state.products = products },
    setPurchasesModel: (state, purchasesModel) => { state.purchasesModel = purchasesModel },
    setLoading: (state, loading) => { state.loading = loading }
}